import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation } from '@angular/core';

import { Action } from '../../action.model';
import { TableRow } from '../../model';
import { ColumnComponent } from '../column.component';
import { InlineAction } from '../shared';

@Component({
  selector: 'tbody[cp-body]',
  templateUrl: './table-body.component.html',
  styleUrls: [
    './table-body.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class TableBodyComponent {
  @Input()
  row: TableRow;

  @Input()
  columns: ColumnComponent[];

  @Input()
  selection: Map<string | number, TableRow>;

  @Input()
  inlineActions: Array<Action<TableRow>>;

  @Input()
  hideActions?: boolean;

  @Input()
  panel?: boolean;

  @Input()
  hideSelection?: boolean;

  @Input()
  secondaryRow?: TemplateRef<any>;

  @Input()
  rowClass?: string;

  @Output()
  toggleSelection = new EventEmitter<TableRow>();

  @Output()
  inlineAction = new EventEmitter<InlineAction<TableRow>>();

  constructor(public element: ElementRef) {
  }

  get isSelected() {
    return this.selection.has(this.row.key);
  }
}



